import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDqbMutation } from '../../api/dqb';
import DQBModal from './DQBModal';

interface DQBProps {
    bookId: any;
}

const DQB: React.FC<DQBProps> = ({ bookId }) => {
    const isopenDQB = useSelector(
        (state: { DQBOpen: { isOpen: boolean } }) => state.DQBOpen.isOpen
    );
    const [dqb, setDQB] = useState<any>([]);
    const [getDqb, { isLoading: isDqbLoading, isError: isDqbError }] =
        useDqbMutation();

    const fetchDQB = async () => {
        getDqb({ book_id: bookId })
            .unwrap() // This ensures we get the result of the mutation (or an error)
            .then((response: any) => {
                // Handle successful launch response
                console.log('DQB successful:', response);
                setDQB(response?.data);
            })
            .catch((error: any) => {
                // Handle error
                console.error('DQB failed:', error);
            });
    };

    useEffect(() => {
        fetchDQB();
    }, []);

    return <>{isopenDQB && <DQBModal dqbItems={dqb} bookId={bookId} />}</>;
};

export default DQB;
